import { createUseStyles } from '@pe-libs/react-components/build/theme';
import { textShadow } from '#modules/expertDirectory/components/SearchSection/helper';

const useStyles = createUseStyles(
  'expert-directory-results',
  ({ breakpoints: { up, down }, typography, shape, palette: { gradient, common } }) => ({
    textShadow: {
      textShadow,
    },
    resultsPage: {
      composes: '$textShadow',

      '& h1': {
        letterSpacing: '0.35px',
        fontSize: '2.125rem',
        lineHeight: '2.5rem',
        marginBottom: '0.5rem',

        [up('sm')]: {
          fontSize: '3rem',
          lineHeight: '3.6rem',
          letterSpacing: '0.4px',
        },
      },
    },
    resultList: {
      padding: 0,
      listStyle: 'none',
      counterReset: 'custom-counter',
    },
    resultSection: {
      display: 'flex',
      padding: '3rem 1rem 4.5rem',
      flexDirection: 'column',
      alignItems: 'flex-start',
      [down('xs')]: {
        padding: '2rem 1rem',
      },
    },
    resultContainer: {
      maxWidth: '47.8125rem',
      width: '100%',
    },
    searchSection: {
      paddingBottom: '4.5rem',
    },
    pagination: {
      display: 'flex',
      margin: '1.5rem auto 0',
      justifyContent: 'flex-end',
      maxWidth: '47.8125rem',
      '& .MuiPagination-root': {
        marginRight: '-8px',
      },
    },
    subtitle: {
      fontSize: '1.125rem',
      letterSpacing: '0.15px',
      display: 'block',
      marginBottom: '1rem',
      [down('sm')]: {
        fontSize: '1rem',
      },
    },
    pageDescription: {
      maxWidth: '50.8125rem',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      fontWeight: typography.fontWeightRegular,
      letterSpacing: '0.15px',
      [up('sm')]: {
        fontSize: '1.25rem',
        lineHeight: '1.875rem',
        letterSpacing: '0.2px',
      },
      margin: '0.5rem auto 2rem',
    },
    center: {
      margin: 'auto',
      textAlign: 'center',
    },
    buttonContainer: {
      display: 'block',
      textAlign: 'right',
      marginBottom: '10px',
      [up('md')]: {
        marginBottom: '2px',
      },
      '& .MuiButton-root': {
        width: '100%',
        [up('sm')]: {
          width: 'auto',
        },
      },
    },
    container: {
      padding: '7rem 1rem 3rem',
      display: 'block',
      margin: 'auto',

      [up('sm')]: {
        padding: '9.5rem 1.5rem 5.5rem',
      },
    },
    hyphensAuto: {
      hyphens: 'auto',
    },
    banner: {
      display: 'flex',
      flexDirection: 'column',
      background: gradient.blue,
      color: common.white,
      borderRadius: shape.borderRadius,
      marginBottom: '1rem',
      overflow: 'hidden',
      textDecoration: 'none',
      boxShadow: '0 3px 4px -2px rgb(0 0 0 / 6%)',

      '@media(min-width: 450px)': {
        flexDirection: 'row',
        height: '9.5rem',
      },

      [up('md')]: {
        height: '6.5rem',
      },

      '&:hover': {
        textDecoration: 'none',
      },
    },
    bannerImage: {
      backgroundSize: 'cover',
      backgroundPosition: 'top center',
      height: '10rem',

      '@media(min-width: 450px)': {
        width: '33%',
        maxWidth: '11.3125rem',
        height: 'auto',
      },

      [up('md')]: {
        width: '8.25rem',
      },

      [up('lg')]: {
        width: '11.625rem',
      },
    },
    bannerContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flex: '1',
      padding: '1.5rem 1rem',

      [up('md')]: {
        padding: '1.5rem',
      },
    },
    bannerLeftContent: {
      paddingRight: '1rem',
    },
    bannerTitle: {
      marginBottom: '0.5rem',
    },
    bannerIcon: {
      flex: '0 0 1rem',
      fontSize: '1rem',
    },
  }),
);

export default useStyles;
